<template>
  <v-slide-y-transition mode="out-in">
    <v-container class=" pa-0 pb-4 fluid">      
      <v-layout column>
        <v-flex sm12>
          <explore-eks v-if="showFormEks"></explore-eks>
          <explore-leg v-if="showFormLeg"></explore-leg>
          <explore-dpd v-if="showFormDpd"></explore-dpd>             
        </v-flex>
      </v-layout>  
    </v-container>
  </v-slide-y-transition>
</template>
<script>
import ExploreEks from './explore-eks';
import ExploreLeg from './explore-leg';
import ExploreDpd from './explore-dpd';

export default {
  components: {
    ExploreEks,
    ExploreLeg,
    ExploreDpd
  },
  data () {
    return {
      //chat: null,
      //selectedTab: null,
    };
  },
  computed: {
    showFormEks() {
      return this.$route.query.mode == 1;
    },
    showFormLeg() {
      return this.$route.query.mode == 2;
    },
    showFormDpd() {
      return this.$route.query.mode == 3;
    },            
  },
};
</script>

